import React from "react";
import { View, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { displayName } from "./types";

export interface GroupFooterProps {
  field: string;
  value: string;
  depth?: number;
  headerFunc?: (s: string) => string;
}

const INDENT_PER_LEVEL = 16;

export function GroupFooter({ field, value, depth = 0, headerFunc = displayName }: GroupFooterProps) {
  const { colors } = useTheme();
  const label = `${headerFunc(field)}: ${value}`;

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: colors.backgroundSecondary,
          borderColor: colors.border,
          paddingLeft: 12 + depth * INDENT_PER_LEVEL,
        },
      ]}
    >
      <ThemedText style={[styles.text, { color: colors.textSecondary }]}>
        ↓ {label} continues on next page...
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderTopWidth: StyleSheet.hairlineWidth,
  },
  text: {
    fontSize: 12,
    fontStyle: "italic",
  },
});
